import styled from '@emotion/styled';
// import { useSetAtom } from 'jotai/react';
import { useRouter } from 'next/router';
import BottomTabBar, { BOTTOM_TAB_BAR_HEIGHT } from 'src/components/BottomTabBar';
import { DirectMessageNavigationProvider, DirectMessagePropsProvider } from 'src/components/DirectMessage/context';
import DirectMessageLobbyBase from 'src/components/DirectMessage/Lobby';
import FooterBase from 'src/components/Footer';
import { FOOTER_VERTICAL_PADDING } from 'src/components/Footer/style';
import Header from 'src/components/Header';
import { TABLET_HEADER_HEIGHT } from 'src/components/Header/styles';
import withPrivateRoute from 'src/components/HOC/withPrivateRoute';
import withWebClientValidation from 'src/components/HOC/withWebClientValidation';
// import WebToAppModal from 'src/components/WebToAppModal';
// import useMount from 'src/hooks/useMount';
import useQuickSlotPage from 'src/hooks/useQuickSlotPage';
import useStartMatch from 'src/hooks/useStartMatch';
import { Routes } from 'src/router/route';
// import { showModalAtom } from 'src/stores/modal/atoms';
// import { ModalType } from 'src/types/Modal';
// import { WebToAppModalType } from 'src/types/WebToApp';

const Container = styled.div`
  width: var(--100vw);
  min-height: var(--100vh, 100dvh);
  display: flex;
  flex-direction: column;
`;
const DirectMessageLobby = styled(DirectMessageLobbyBase)`
  flex: 1;
  min-height: calc(var(--100vh, 100dvh) - ${BOTTOM_TAB_BAR_HEIGHT});

  ${({
  theme
}) => theme.screenSize.tablet} {
    padding-block-start: ${TABLET_HEADER_HEIGHT};
  }
`;
const Footer = styled(FooterBase)`
  ${({
  theme
}) => theme.screenSize.tablet} {
    padding-bottom: calc(${FOOTER_VERTICAL_PADDING} + ${BOTTOM_TAB_BAR_HEIGHT});
  }
`;
const MessagesView = () => {
  const router = useRouter();
  const {
    startMatch: openMatch
  } = useStartMatch();
  const openRoom = (messageThreadId: string) => {
    router.push({
      ...Routes['/messages/room'](),
      query: {
        messageThreadId
      }
    });
  };
  const openFollowing = () => {
    router.push({
      ...Routes['/follow'](),
      query: {
        tab: 'following'
      }
    });
  };
  const openFollower = () => {
    router.push({
      ...Routes['/follow'](),
      query: {
        tab: 'follower'
      }
    });
  };
  const closeRoom = () => {};
  useQuickSlotPage('FRIEND_ADD_REQUEST');

  /** TODO: Vividi iOS 리뷰 통과 후 오픈 */
  // const showModal = useSetAtom(showModalAtom);
  // useMount(() => {
  //   showModal({
  //     key: ModalType.WEB_TO_APP,
  //     component: () => <WebToAppModal type={WebToAppModalType.MESSAGE} />,
  //   });
  // });

  return <DirectMessageNavigationProvider closeRoom={closeRoom} openMatch={openMatch} openRoom={openRoom} openFollowing={openFollowing} openFollower={openFollower} data-sentry-element="DirectMessageNavigationProvider" data-sentry-component="MessagesView" data-sentry-source-file="Messages.tsx">
      <DirectMessagePropsProvider messageThreadId={null} data-sentry-element="DirectMessagePropsProvider" data-sentry-source-file="Messages.tsx">
        <Container data-sentry-element="Container" data-sentry-source-file="Messages.tsx">
          <Header data-sentry-element="Header" data-sentry-source-file="Messages.tsx" />
          <DirectMessageLobby data-sentry-element="DirectMessageLobby" data-sentry-source-file="Messages.tsx" />
          <BottomTabBar data-sentry-element="BottomTabBar" data-sentry-source-file="Messages.tsx" />
          <Footer data-sentry-element="Footer" data-sentry-source-file="Messages.tsx" />
        </Container>
      </DirectMessagePropsProvider>
    </DirectMessageNavigationProvider>;
};
export default withWebClientValidation(withPrivateRoute(MessagesView));